// react and mui stuff
import { useState } from "react";

import { PieChart } from "@mui/x-charts/PieChart";
import Typography from "@mui/joy/Typography";

// custom components
import { FetchButton, ReportProps } from "./utils";

// data and stuff
import { HouseReport } from "../../types/reports";
import { reportAPI } from "../../utils/backend"

type PieReportProps = {
  report: HouseReport[]
  reportKey: "em" | "members" | "xp"
  label: string
}

function PieReport({ report, reportKey, label }: PieReportProps) {
  return (
    <div className="flexMidVert" style={{ flexDirection: "column" }}>
      <Typography level="h2">{label}</Typography>
      <PieChart
        slotProps={{ legend: { hidden: true } }}
        height={200}
        series={[{ data: report.map(r => ({ id: r.name, value: r[reportKey], label: r.name, color: r.color })) }]}
        dataset={report}
        width={200}
        margin={{ top: 10, left: 0, bottom: 10, right: 0 }}
      />
      <br/>
    </div>
  )
}

export default function HousesReport({ report, setReport, setToast, setUser, user }: ReportProps<HouseReport[]>) {
  const [loading, setLoading] = useState(false);
  
  return (
    <div>
      {!report &&
        <FetchButton
          user={user}
          apiFunction={reportAPI.getHouses}
          loading={loading}
          setLoading={setLoading}
          setReport={setReport}
          setToast={setToast}
          setUser={setUser}
        />
      }
      {report &&
      <>
        <PieReport label="Members Per House" report={report} reportKey="members"/>
        <PieReport label="XP Per House" report={report} reportKey="xp"/>
        <PieReport label="Season Ember Distribution" report={report} reportKey="em"/>
      </>
      }
    </div>
  )
}